<div class="ticket-item-card-wrapper">
  <div class="ticket-item-card" (click)="onSelectTicket()">
    <div class="ticket-item-cont">
      <div class="ticket-item-title-cont">
        <div class="ticket-item-title">
          Ticket {{ orderTicket.ticketNumber }}
        </div>
        @if (!orderTicket.eventAttendee) {
          <i
            class="fa-regular fa-circle-exclamation icon-regular warning-icon"
            [matTooltip]="
              'APP.TICKETS_DASHBOARD.ASSIGN_TICKET_INFO' | translate
            "
          ></i>
        }
      </div>

      <div class="ticket-item-user-data-cont">
        @if (orderTicket.eventAttendee) {
          <div class="ticket-item-user-data">
            <i class="fa-regular fa-user icon-regular"></i>
            <div class="ticket-item-user-data-value">
              {{ orderTicket.eventAttendee.getName() }}
            </div>
          </div>
          <div class="ticket-item-user-data">
            <i class="fa-regular fa-envelope icon-regular"></i>
            <div class="ticket-item-user-data-value">
              {{ orderTicket.eventAttendee.getEmail() }}
            </div>
          </div>
        } @else {
          <div class="ticket-item-user-data data-missing">
            <i class="fa-regular fa-user icon-regular"></i>
            <div class="ticket-item-user-data-value">
              {{ "APP.DATA_MISSING" | translate }}
            </div>
          </div>
          <div class="ticket-item-user-data data-missing">
            <i class="fa-regular fa-envelope icon-regular"></i>
            <div class="ticket-item-user-data-value">
              {{ "APP.DATA_MISSING" | translate }}
            </div>
          </div>
        }
      </div>
    </div>

    <div class="ticket-copy-cont" (click)="onForwardTicket($event)">
      @if (!orderTicket.eventAttendee) {
        <i class="fa-regular fa-copy icon-regular"></i>
      }
    </div>
  </div>
</div>
